/* ══════════════════════════════════════════════════════════════════
   EB CORE —— 全站共用运行时。滚动锁、焦点陷阱、浮层登记、断点、事件总线。
   任何浮层（抽屉 / 超级菜单 / 搜索 / 购物车 / 弹窗）都走这里，不各写一套。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var FOCUSABLE = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  /* ── 滚动锁：引用计数，多个浮层叠加不会提前解锁 ── */
  var lockCount = 0;
  var savedY = 0;

  function lockScroll() {
    if (lockCount === 0) {
      savedY = window.scrollY;
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.top = '-' + savedY + 'px';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
      document.body.classList.add('eb-scroll-locked');
    }
    lockCount++;
  }

  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount > 0) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';
    document.body.classList.remove('eb-scroll-locked');
    window.scrollTo(0, savedY);
  }

  /* ── 焦点陷阱 ── */
  function trapFocus(container, initial) {
    if (!container) return function () {};
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(
        container.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    var target = initial || container.querySelector(FOCUSABLE);
    if (target) window.requestAnimationFrame(function () { target.focus(); });
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* ── 浮层登记：同一时间只允许一个独占浮层 ── */
  var overlays = {};
  var activeId = null;
  var scrim = null;

  function getScrim() {
    if (!scrim) scrim = document.querySelector('[data-eb-scrim]');
    return scrim;
  }

  function register(id, api) { overlays[id] = api; }

  function open(id, opts) {
    if (activeId && activeId !== id) close(activeId, { silent: true });
    var api = overlays[id];
    if (!api) return;
    activeId = id;
    if (api.lock !== false) lockScroll();
    if (api.scrim !== false) {
      var s = getScrim();
      if (s) { s.hidden = false; window.requestAnimationFrame(function () { s.classList.add('is-open'); }); }
    }
    if (typeof api.onOpen === 'function') api.onOpen(opts || {});
    emit('overlay:open', { id: id });
  }

  function close(id, opts) {
    id = id || activeId;
    var api = overlays[id];
    if (!api) return;
    if (api.lock !== false) unlockScroll();
    if (api.scrim !== false) {
      var s = getScrim();
      if (s) {
        s.classList.remove('is-open');
        window.setTimeout(function () { if (!s.classList.contains('is-open')) s.hidden = true; }, 420);
      }
    }
    if (typeof api.onClose === 'function') api.onClose(opts || {});
    if (activeId === id) activeId = null;
    emit('overlay:close', { id: id });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeId) close(activeId);
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-eb-scrim') && activeId) close(activeId);
  });

  /* ── 原生 <details> 当菜单用时缺的那两件事 ──────────────────
     <details> 自带开合、键盘和读屏器语义，唯独没有「点别处关掉」和 Esc。
     补在这里而不是各 section 各写一份：任何标了 data-eb-menu 的 <details>
     都自动获得这两个行为，region-picker 只是第一个用它的。 */
  function closeMenus(except) {
    Array.prototype.forEach.call(document.querySelectorAll('details[data-eb-menu][open]'), function (d) {
      if (d !== except) d.open = false;
    });
  }

  document.addEventListener('click', function (e) {
    var inside = e.target.closest ? e.target.closest('details[data-eb-menu]') : null;
    closeMenus(inside);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('details[data-eb-menu][open]');
    if (!open) return;
    /* 浮层的 Esc 归 overlay 管，这里只在没有浮层开着时接管 */
    if (activeId) return;
    e.stopPropagation();
    open.open = false;
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  }, true);

  /* ── 事件总线。section 之间通信走这里，不直接互相引用。 ── */
  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent('eb:' + name, { detail: detail || {} }));
  }
  function on(name, fn) {
    document.addEventListener('eb:' + name, fn);
    return function () { document.removeEventListener('eb:' + name, fn); };
  }

  /* ── 断点。全站只有这两个，section 不自己写 matchMedia。 ── */
  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var mqTablet = window.matchMedia('(min-width: 769px)');
  function isDesktop() { return mqDesktop.matches; }
  function isMobile() { return !mqTablet.matches; }
  function onBreakpoint(fn) {
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', fn);
    else mqDesktop.addListener(fn);
  }

  /* ── 小工具 ── */
  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait || 150);
    };
  }
  function throttle(fn, wait) {
    var last = 0, timer;
    return function () {
      var now = Date.now(), ctx = this, args = arguments;
      if (now - last >= (wait || 100)) { last = now; fn.apply(ctx, args); }
      else { clearTimeout(timer); timer = setTimeout(function () { last = Date.now(); fn.apply(ctx, args); }, wait); }
    };
  }
  function money(cents) {
    return (window.Shopify && window.Shopify.formatMoney)
      ? window.Shopify.formatMoney(cents)
      : (cents / 100).toFixed(2);
  }

  window.EB = {
    FOCUSABLE: FOCUSABLE,
    lockScroll: lockScroll,
    unlockScroll: unlockScroll,
    trapFocus: trapFocus,
    overlay: { register: register, open: open, close: close, active: function () { return activeId; } },
    emit: emit,
    on: on,
    isDesktop: isDesktop,
    isMobile: isMobile,
    onBreakpoint: onBreakpoint,
    debounce: debounce,
    throttle: throttle,
    money: money
  };
})();
